import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.Vendedor;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

/**
* Valida un Vendedor
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {};
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class VendedorFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;

        const hasError = this.hasError(this.props);
        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);
        const Sucursal = getField(selectores.Sucursal);
        return (
            <div>
                <kea.Title titulo="Vendedor" onRegresar={() => history.go("/catalogos/vendedores")} />
                {kea.autogrid(3, [
                    <Sucursal field="IdSucursal" label="Sucursal" />,
                    <Text field="Nombre" />,
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>
            </div>);
    }
}

export const VendedorForm = componentToRx(VendedorFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/vendedores/edit/form.tsx